import { FC, ReactNode } from 'react'

import styles from './Main.module.scss'

type Props = {
  children?: ReactNode
}

const Main: FC<Props> = ({ children }) => <div className={styles.main}>{children}</div>

export default Main
